<template>
    <div class="header-meditatiocds">
        <div class="container">
            <!--
            <div class="text-right hidden-sm-and-down">
                <div v-if="!isAuthenticated" >
                    <v-btn 
                        small
                        to="/admin"
                    >
                        Reserved Area
                    </v-btn>
                </div>
                <div v-else>
                    <v-btn 
                        small
                        @click="logout"
                    >
                        Hi admin | Logout
                        <v-icon right>mdi-logout</v-icon>
                    </v-btn>
                </div>
            </div>
            -->
            <h1 class="text-hide logo-wccm"><a href="https://www.wccm.org/">WCCM | The World Community for Christian Meditation</a></h1>
            <h2 class="claim-page">Meditatio <br class="d-flex d-sm-none"><strong>Talks Series</strong></h2>
        </div>
    </div>
</template>


<style lang="scss">
.v-navigation-drawer .v-list-item--active {
    color: #fff;
}
a.appTitle {
    text-decoration: none;
    text-transform: uppercase;
    color: #fff;
    &-active:before {
       display: none
    }
}

.header-meditatiocds {
    position: relative;
    padding: 30px 0;
    .container {
        position: relative;
        z-index: 3;
    }
    &::before {
        content: '';
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url(../assets/img/doves.jpg);
        background-size: cover;
        filter: contrast(.3);
    }
    &::after {
        content: '';
        z-index: 2;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: linear-gradient(transparent, #fff);
    }      
    h1.logo-wccm {
        display: block;
        background-position: left top;
        background-repeat: no-repeat;
        margin-bottom: 30px;
        width: 331px;
        height: 67px;
        background-image: url(../assets/img/wccm_logo_big.png);
        a {
            display: block;
            width: 100%;
            height: 100%;
        }
    }
    h2.claim-page {
        font-size: 4em;
        line-height: 1.1em;
        color: #fff;
        text-shadow: 3px 3px #000;
        font-weight: 500;
        strong {
            font-weight: 800;
        }
    }
}

@media (max-width: 768px) {
    .header-meditatiocds{
        text-align: center;
        h1.logo-wccm {
            margin: 0 auto 20px auto;
        }
        h2.claim-page {
            font-size: 3em;
            text-shadow: 2px 2px #000;
        }
    }
}
</style>

<script>
export default {
    name: 'Header',
    data() {
        return {      
        };
    },
    computed: {
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('userLogOut');
        }
    }
};
</script>